import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyAccountComponent } from '../account/components/my-account/my-account.component';
import { AccountService } from '../account/services/account.service';
import { AccountComponent } from '../account/account.component';
import { LogInComponent } from '../account/components/log-in/log-in.component';
import { RegisterComponent } from '../account/components/register/register.component';
import { ProfileComponent } from '../account/components/profile/profile.component';
import { EditProfileComponent } from '../account/components/edit-profile/edit-profile.component';
import { ChangePinComponent } from '../account/components/change-pin/change-pin.component';
import { ChangeEmailComponent } from '../account/components/change-email/change-email.component';
import { DownloadAppComponent } from '../account/components/download-app/download-app.component';
import { LoginService } from '../account/services/login.service';
import { AuthorizeService } from '../account/services/authorize.service';
import { TokenService } from '../account/services/token.service';
import { PhoneMaskDirective } from '../account/directives/phoneMask.directive';
import { OnlyNumberDirective } from '../account/directives/onlyNumber.directive';
import { CookieManagementService } from '../account/services/cookie-management.service';
import { UpdateProfileService } from '../account/services/update-profile.service';
import { ValidateService } from '../account/services/validate.service';
import { ConfirmService } from '../account/services/confirm.service';
import { ChangePinService } from '../account/services/change-pin.service';
import { OtpService } from '../account/services/otp.service';
import { SharedModule } from '../utility-packages/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import {RouterModule} from '@angular/router';
import { AccountRoutingModule } from './account-routing.module';
import { EffectsModule } from '@ngrx/effects';
import { AccountEffects } from './ngrx/account-effects';
import { StoreModule } from '@ngrx/store';
import * as fromAccount from './ngrx/account-reducers';
import { AccountResolver } from './ngrx/account-resolver';
import { AccountModuleDisplayConfig, ACCOUNT_DISPLAY_CONFIG } from './module-config/module-config';
import { ResponsiveAccountDirective } from './directives/responsive-account.directive';

@NgModule({
  declarations: [
    MyAccountComponent,
    AccountComponent,
    LogInComponent,
    RegisterComponent,
    ProfileComponent,
    EditProfileComponent,
    ChangePinComponent,
    ChangeEmailComponent,
    DownloadAppComponent,
    PhoneMaskDirective,
    OnlyNumberDirective,
    ResponsiveAccountDirective,
  ],
  providers:[
    AccountService,
    LoginService,
    AuthorizeService,
    TokenService,
    CookieManagementService,
    UpdateProfileService,
    ValidateService,
    ConfirmService,
    ChangePinService,
    OtpService,
    AccountResolver,
      {
        provide: ACCOUNT_DISPLAY_CONFIG,
        useFactory: SettingFactory
      }
  ],
  imports: [
    CommonModule,
    EffectsModule.forFeature([AccountEffects]),
    StoreModule.forFeature("account", fromAccount.accreducer),
    SharedModule,
    TranslateModule.forChild({}),
    FormsModule,
    RouterModule,
    AccountRoutingModule
  ],
  exports: [
    MyAccountComponent,
    AccountComponent,
    LogInComponent
  ]
})
export class AccountModule {
  static settings: AccountModuleDisplayConfig;
}

export function SettingFactory() {
  return AccountModule.settings;
}
